import { MatriceView } from "@/pages/MensaMatricePage";

export default function ExtraMatricePage() {
  return <MatriceView />;
}
